import React, { useContext } from 'react';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import { RecallsUnitedVehicleData } from '../../pages/recalls-united/recalls-united';
import PreImagineVINSelector from '../../../components/sections/pre-imagine-components/pre-imagine-vehicle-selector/pre-imagine-vin-selector/pre-imagine-vin-selector';
import { scrollToRecallsResults } from '../recalls-information-section/recalls-information-section';
import siteMapService from '../../services/site-map-service/site-map-service';
import ServerContext from '../../../contexts/serverContext';

interface RecallsVinInputProps {
    content: RecallsUnitedContent;
    onSelect: (data: RecallsUnitedVehicleData) => void;
    closeDrawer?: () => void;
    hasUsername?: string | null;
    noVehicles?: boolean;
}

export const RecallVinInput = (props: RecallsVinInputProps) => {
    const { content, closeDrawer, hasUsername, onSelect } = props;
    const serverContext = useContext(ServerContext);
    const onSubmit = () => {
        closeDrawer?.();
        scrollToRecallsResults();
    };
    const path = siteMapService
        .getPathFromRouterConfigs(
            serverContext.currentLanguageRegionCode,
            serverContext.brand,
            'RecallsUnited',
            []
        )
        .replace(':vinOrModel?/:year?/', '');
    return (
        <>
            {content.vinInputTitle && (
                <div
                    className={`recalls-vin-section`}
                    data-testid="recall-vin-input"
                >
                    <div className="recalls-vin-title">
                        {content.recallsInformationUpToThisDateText}
                    </div>
                    <div
                        className={`recalls-vin-input${
                            hasUsername ? ' with-light-button' : ''
                        }`}
                    >
                        <PreImagineVINSelector
                            submitLabel={content.vinSearchCtaLabel}
                            findMyVinLabel={content.whereDoIFindMyVinTitle}
                            findMyVinLink={content.whereDoIFindMyVinLink}
                            altLabel={content.vinLabel}
                            redirectData={{ path: path, id: 'recalls-united' }}
                            vinPlaceholderLabel={' '}
                            setVehicleTypeInformation={onSelect}
                            handleVinSubmit={onSubmit}
                            vinHeaderLabel={content.vinInputTitle}
                            buttonType={hasUsername ? 'secondary' : 'primary'}
                            page="RecallsUnited"
                            disableButtonDisabledState={true}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
